<template>
  <div class="page">
    <div class="fr ac fw">
      <div class="img-item ml20 mt20" v-for="(item,index) in file_lis" :key="index">
        <el-image
            :src="item.img_url"
            class="avatar cursor"
            v-if="item.pdf_url"
            @load="onImageLoad"
            @click="openPdf(item.pdf_url)"
        ></el-image>
        <el-image
            v-else
            :src="item.img_url"
            class="avatar"
            @load="onImageLoad"
            :preview-src-list="file_list"
        ></el-image>
        <i @click="deleteItem(index)" class="el-icon-error delete cursor" v-if="!disabled"/>
      </div>

      <!--          加载中-->

      <div
          v-loading="up_loading"
          spinner="el-icon-loading"
          v-if="up_loading"
          class="img-item ml20 mt20 avatar"
      ></div>
      <template v-if="!disabled">
        <div
            v-if="limit>file_list.length  && !img_loading && !up_loading"
            tabindex="0"
            class="el-upload el-upload--picture-card mt20 ml20"
            style="position: relative"
        >
          <i class="el-icon-plus bg_white"></i>

          <input type="file" name="file" multiple :accept="file_type" class="el-upload__input file cursor"
                 @change="uploadFile"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 公共包：图片按需压缩 + 文件校验（仓库 https://gitee.com/peijingbin/ky-shared ，修 bug 请改公共包并发新 tag）
import {compressFiles, checkFiles} from "ky-shared";

const default_img = "https://img.beltdance.com/app/mobile_end_img/pdf_view.png";
export default {
  props: {
    file_list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 6,
    },
    file_type: {
      type: String,
      default: 'image/*,application/pdf,application/PDF'
    }
  },
  data() {
    return {
      //上传中完成
      up_loading: false,
      //加载完成
      img_loading: false,
      file_lis: [],
    };
  },
  mounted() {
    let arr = [];
    this.file_list.forEach((el) => {
      let obj = {};
      if (/\.pdf$/i.test(el)) {
        obj.pdf_url = el;
        obj.img_url = default_img;
      } else {
        obj.pdf_url = null;
        obj.img_url = el;
      }
      arr.push(obj);
    });
    this.file_lis = JSON.parse(JSON.stringify(arr));
  },
  watch: {
    file_list(n) {
      let arr = [];
      n.forEach((el) => {
        let obj = {};
        if (/\.pdf$/i.test(el)) {
          obj.pdf_url = el;
          obj.img_url = default_img;
        } else {
          obj.pdf_url = null;
          obj.img_url = el;
        }
        arr.push(obj);
      });
      this.file_lis = JSON.parse(JSON.stringify(arr));
    },
  },
  computed: {
    maxLength() {
      return this.sub(this.$props.limit, this.file_list.length);
    }
  },

  methods: {
    openPdf(url) {
      window.open(`https://wx.beltdance.com/pdf/web/viewer.html?file=${url}`);
    },
    //上传成功（input 已带 multiple，支持一次选多张）
    async uploadFile(e) {
      // FileList 转真数组，方便 map 处理
      let files = Array.from(e.target.files);
      // 清空 input 的值：否则删除后再选同一个文件不会触发 change 事件
      e.target.value = "";
      //数量/格式校验（错误文案由公共包生成，弹窗方式各项目自定）
      const typeErr = checkFiles(files, {
        accept: this.$props.file_type,
        remainCount: this.maxLength,
        limit: this.$props.limit,
        existCount: this.file_list.length,
      });
      if (typeErr) {
        this.$message.warning(typeErr);
        return;
      }

      this.up_loading = true;
      try {
        // 图片过大就压缩后再传；PDF 等非图片文件不压缩，原样上传（逻辑在 ky-shared 公共包）
        files = await compressFiles(files);
        // 大小校验放在压缩之后：大图先压缩，压缩完还超过5M才拦截
        const sizeErr = checkFiles(files, {maxSizeMB: 5});
        if (sizeErr) {
          this.$message.warning(sizeErr);
          return;
        }
        let imgUrl = await this.upload(files);
        imgUrl = imgUrl.split(",");
        imgUrl.forEach(el => {
          this.file_list.push(el);
        })
        this.img_loading = true;
      } finally {
        // 无论成功失败都要关闭 loading，避免上传报错后一直转圈
        this.up_loading = false;
      }
    },
    //压缩/校验逻辑已迁移到 ky-shared 公共包（compressFiles / checkFiles，见 uploadFile）
    deleteItem(index) {
      this.file_list.splice(index, 1);
    },
    //  图片上传完成 加载完成
    onImageLoad() {
      this.img_loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  // width: 1200px;
  font-size: 14px;
  // margin: 0 auto;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #f5f5f5;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
  border: 1px solid #f5f5f5;
  border-radius: 6px;
}

.img-item {
  position: relative;

  .delete {
    font-size: 30px;
    position: absolute;
    right: -5px;
    top: -5px;
  }
}

.file {
  position: absolute;
  width: 140px;
  height: 140px;
  left: 0;
  top: 0;
  opacity: 0;

  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/UploadImg.vue